import * as pageManager from '@trullock/page-manager';
import { createApp } from 'vue';
import Page from '../js/page.js';


import * as PageLoading from './loading.vue'
registerVuePage(PageLoading);
import * as PageError from './error.vue'
registerVuePage(PageError);
import * as PageError404 from './error-404.vue'
registerVuePage(PageError404);
import * as PageError403 from './account/forbidden.vue'
registerVuePage(PageError403);


import * as PagePrivacyPolicy from './privacy-policy.vue'
registerVuePage(PagePrivacyPolicy);
import * as PageTermsOfService from './terms-of-service.vue'
registerVuePage(PageTermsOfService);


import * as PageDashboard from './dashboard/dashboard.vue'
registerVuePage(PageDashboard);


import * as PageValidate from './dashboard/validate.vue'
registerVuePage(PageValidate);

import * as PageMembership from './membership/membership.vue'
registerVuePage(PageMembership);
import * as PageMembershipResult from './membership/membership-result.vue'
registerVuePage(PageMembershipResult);


import * as PageMembershipBuyCard from './membership/buy-card.vue'
registerVuePage(PageMembershipBuyCard);
import * as PageMembershipCardCheckout from './membership/card-checkout.vue'
registerVuePage(PageMembershipCardCheckout);
import * as PageMembershipBuyCardResult from './membership/card-checkout-result.vue'
registerVuePage(PageMembershipBuyCardResult);

import './account/sign-out.js';
import './account/email-verify-complete.js';

import * as PageAccountSignIn from './account/sign-in.vue'
registerVuePage(PageAccountSignIn);
import * as PageAccountSignUp from './account/sign-up.vue'
registerVuePage(PageAccountSignUp);
import * as PageAccountResetPassword from './account/reset-password.vue'
registerVuePage(PageAccountResetPassword);
import * as PageAccountSetPassword from './account/set-password.vue'
registerVuePage(PageAccountSetPassword);
import * as PageAccountSecurity from './account/security.vue'
registerVuePage(PageAccountSecurity);
import * as PageAccountChangeEmail from './account/change-email.vue'
registerVuePage(PageAccountChangeEmail);
import * as PageAccountPreferencesProper from './account/preferences.vue'
registerVuePage(PageAccountPreferencesProper);
import * as PageAccountPreferences from './account/account.vue'
registerVuePage(PageAccountPreferences);
import * as PageAccountComplete from './account/complete.vue'
registerVuePage(PageAccountComplete);
import * as PageAccountEmailVerify from './account/email-verify.vue'
registerVuePage(PageAccountEmailVerify);
import * as PageAccountInsurance from './account/insurance.vue'
registerVuePage(PageAccountInsurance);
import * as PageAccountDelete from './account/delete.vue'
registerVuePage(PageAccountDelete);
import * as PageAccountSAR from './account/subject-access-request.vue'
registerVuePage(PageAccountSAR);
import * as PageAccountPasswordStrength from './account/password-strength.vue'
registerVuePage(PageAccountPasswordStrength);
import * as PageAccountPaymentHistory from './account/payment-history.vue'
registerVuePage(PageAccountPaymentHistory);
import * as PageAccountLicensing from './account/licensing.vue'
registerVuePage(PageAccountLicensing);
import * as PageAccountDBS from './account/dbs.vue'
registerVuePage(PageAccountDBS);


import * as PageCertLevel1 from './certification/level1.vue'
registerVuePage(PageCertLevel1);
import * as PageCertLevel2 from './certification/level2.vue'
registerVuePage(PageCertLevel2);
import * as PageCertLevel3 from './certification/level3.vue'
registerVuePage(PageCertLevel3);
import * as PageCertRSO from './certification/rso.vue'
registerVuePage(PageCertRSO);
// needs registering first because of routing
import * as PageCertBuyResult from './certification/buy-certificate-result.vue'
registerVuePage(PageCertBuyResult);
import * as PageCertBuy from './certification/buy-certificate.vue'
registerVuePage(PageCertBuy);



import * as PageTPS from './tps/tps.vue'
registerVuePage(PageTPS);



import * as PageMAP from './map/map.vue'
registerVuePage(PageMAP);
import * as PageMAPAssessor from './map/assessor.vue'
registerVuePage(PageMAPAssessor);
import * as PageMAPAssessors from './map/list-assessors.vue'
registerVuePage(PageMAPAssessors);
import * as PageMAPViewTask from './map/view-task.vue'
registerVuePage(PageMAPViewTask);
import * as PageMAPPrintable from './map/printable.vue'
registerVuePage(PageMAPPrintable);




import * as PageRecords from './records/records.vue'
registerVuePage(PageRecords);
import * as PageRecordsType from './records/records-type.vue'
registerVuePage(PageRecordsType);

import * as PageFlightsRockets from './flights/rockets.vue'
registerVuePage(PageFlightsRockets);
import * as PageFlightsRocketsAdd from './flights/rocket-add.vue'
registerVuePage(PageFlightsRocketsAdd);
import * as PageFlightsRocketsView from './flights/rocket-view.vue'
registerVuePage(PageFlightsRocketsView);
import * as PageFlightsRocketsEdit from './flights/rocket-edit.vue'
registerVuePage(PageFlightsRocketsEdit);
import * as PageFlightsAdd from './flights/flight-add.vue'
registerVuePage(PageFlightsAdd);
import * as PageFlightsView from './flights/flight-view.vue'
registerVuePage(PageFlightsView);
import * as PageFlightsEdit from './flights/flight-edit.vue'
registerVuePage(PageFlightsEdit);
import * as PageFlightLogView from './flights/flight-log-view.vue'
registerVuePage(PageFlightLogView);

import * as PageInventoryMotors from './inventory/motors.vue'
registerVuePage(PageInventoryMotors);
import * as PageInventoryMotorsUsage from './inventory/motors-usage.vue'
registerVuePage(PageInventoryMotorsUsage);
import * as PageInventoryMotorsAdd from './inventory/motors-add.vue'
registerVuePage(PageInventoryMotorsAdd);
import * as PageInventoryMotorsEdit from './inventory/motors-edit.vue'
registerVuePage(PageInventoryMotorsEdit);

import * as PageClubs from './clubs/clubs.vue'
registerVuePage(PageClubs);
import * as PageClubView from './clubs/club-view.vue'
registerVuePage(PageClubView);
import * as PageClubEdit from './clubs/club-edit.vue'
registerVuePage(PageClubEdit);
import * as PageClubRegularEventAdd from './clubs/club-regular-event-add.vue'
registerVuePage(PageClubRegularEventAdd);
import * as PageClubSpecialEventAdd from './clubs/club-special-event-add.vue'
registerVuePage(PageClubSpecialEventAdd);


import * as PageTools from './tools/tools.vue'
registerVuePage(PageTools);
import * as PageToolsVentHoles from './tools/vent-holes.vue'
registerVuePage(PageToolsVentHoles);
import * as PageToolsEjectionCharge from './tools/ejection-charge.vue'
registerVuePage(PageToolsEjectionCharge);
import * as PageToolsParachute from './tools/parachute-calculator.vue'
registerVuePage(PageToolsParachute);
import * as PageToolsLaunchSites from './tools/launch-sites.vue'
registerVuePage(PageToolsLaunchSites);
import * as PageToolsNotamList from './tools/notam-list.vue'
registerVuePage(PageToolsNotamList);
import * as PageToolsTracker from './tools/tracker.vue'
registerVuePage(PageToolsTracker);
import * as PageToolsRSOList from './tools/list-rsos.vue'
registerVuePage(PageToolsRSOList);


import * as PageAdmin from './admin/admin.vue'
registerVuePage(PageAdmin);
import * as PageAdminViewUser from './admin/user-view.vue'
registerVuePage(PageAdminViewUser);
import * as PageAdminViewFulfillment from './admin/user-fulfillment.vue'
registerVuePage(PageAdminViewFulfillment);
import * as PageAdmiEditUser from './admin/user-edit.vue'
registerVuePage(PageAdmiEditUser);
import * as PageAdmiUserHistory from './admin/user-history.vue'
registerVuePage(PageAdmiUserHistory);
import * as PageAdminApprovalsView from './admin/attempt-view.vue'
registerVuePage(PageAdminApprovalsView);
import * as PageAdminMAPApprovalsView from './admin/map-attempt-view.vue'
registerVuePage(PageAdminMAPApprovalsView);
import * as PageAdminRecordApprovalsView from './admin/record-attempt-view.vue'
registerVuePage(PageAdminRecordApprovalsView);
import * as PageAdminEmail from './admin/email.vue'
registerVuePage(PageAdminEmail);
import * as PageAdminEmailCampaigns from './admin/email-campaigns.vue'
registerVuePage(PageAdminEmailCampaigns);
import * as PageAdminEmailCampaignAdd from './admin/email-campaign-add.vue'
registerVuePage(PageAdminEmailCampaignAdd);
import * as PageAdminEmailCampaignEdit from './admin/email-campaign-edit.vue'
registerVuePage(PageAdminEmailCampaignEdit);
import * as PageAdminEmailCampaignView from './admin/email-campaign-view.vue'
registerVuePage(PageAdminEmailCampaignView);
import * as PageAdminImport from './admin/import.vue'
registerVuePage(PageAdminImport);
import * as PageAdminUpdate from './admin/update.vue'
registerVuePage(PageAdminUpdate);
import * as PageAdminReports from './admin/reports.vue'
registerVuePage(PageAdminReports);
import * as PageAdminReportsNewlyAwarded from './admin/newly-awarded.vue'
registerVuePage(PageAdminReportsNewlyAwarded);
import * as PageAdminInsuranceChecker from './admin/insurance-checker.vue'
registerVuePage(PageAdminInsuranceChecker);

import { connectFormComponents } from '../js/utils/forms.js';

function registerVuePage(page)
{
	pageManager.registerPage(page.pageName, page.pageRoute, class extends Page {

		static fetchHTML = false
		static requireAuth = page.requireAuth !== false;
		static requireAdmin = page.requireAdmin === true;
		static requireMembership = page.requireMembership === true;
		static requireCompleteAccount = page.requireCompleteAccount === true;
		static requireEmailVerified = page.requireEmailVerified !== false;
		static furniture = page.furniture || 'full';
		static cacheMarkupBy = page.cacheMarkupBy || 'path'

		get title() {
			if(this.app._instance.ctx.title)
				return this.app._instance.ctx.title + ' | UKRA';
			if(page.title)
				return page.title + ' | UKRA';
			
			return 'UKRA';
		}

		beforeHide() {
			if(this.app._instance.ctx.beforeHide)
				return this.app._instance.ctx.beforeHide();
			return undefined;
		}

		async boot(opts) {
			let p = page.default;
			let $page = this.$page
			
			let origMounted = p.mounted
			p.mounted = function() {
				connectFormComponents($page)
				origMounted && origMounted.call(this)
			};
			// this doesnt always fire, if the vue page doesnt update its data on load, so we also need mounted() above
			p.updated = function() {
				connectFormComponents($page)
			};

			this.app = createApp(p);
			this.app.mount(this.$page)	

			this.app._instance.ctx.__defineGetter__("visible", () => this.visible);

			// diabolical Vue hack, this will probably break between Vue version upgrades
			if(this.app._instance.ctx.boot)
				await Promise.resolve(this.app._instance.ctx.boot(opts));
		}

		async update(opts)
		{
			// diabolical Vue hack, this will probably break between Vue version upgrades
			// TODO: dont call show, can we have a new method or always call update (on show)
			if(this.app._instance.ctx.show)
				await Promise.resolve(this.app._instance.ctx.show(opts));
			await super.update(opts);
		}

		async show(opts)
		{
			// diabolical Vue hack, this will probably break between Vue version upgrades
			if(this.app._instance.ctx.show)
				await Promise.resolve(this.app._instance.ctx.show(opts));
			await super.show(opts);
		}

		async hide()
		{
			// diabolical Vue hack, this will probably break between Vue version upgrades
			if(this.app._instance.ctx.hide)
				await Promise.resolve(this.app._instance.ctx.hide());
			await super.hide();
		}
	})
}